import React from 'react';
import {
  FacebookIcon,
  FacebookShareButton,
  HatenaIcon,
  HatenaShareButton,
  LineIcon,
  LineShareButton,
  TwitterIcon,
  TwitterShareButton,
} from 'react-share';
import styled from 'styled-components';
import media from 'styled-media-query';

const Share = styled.div`
  grid-area: share;
  justify-self: end;
  align-self: start;
  ${media.lessThan('medium')`
    justify-self: center;
    width: 50%;
    flex-flow: row;
    justify-content: space-between
  `}
  display: flex;
  flex-flow: column;
  position: sticky;
  top: 3rem;
`;

const ButtonWrapper = styled.div`
  margin: 0.5rem 0;
`;

const ShareButtonList: React.VFC<{ title: string; url: string }> = ({
  title,
  url,
}) => {
  return (
    <Share>
      <ButtonWrapper>
        <FacebookShareButton url={url}>
          <FacebookIcon size={40} round />
        </FacebookShareButton>
      </ButtonWrapper>

      <ButtonWrapper>
        <LineShareButton url={url}>
          <LineIcon size={40} round />
        </LineShareButton>
      </ButtonWrapper>

      <ButtonWrapper>
        <TwitterShareButton title={title} url={url}>
          <TwitterIcon size={40} round />
        </TwitterShareButton>
      </ButtonWrapper>

      <ButtonWrapper>
        <HatenaShareButton url={url}>
          <HatenaIcon size={40} round />
        </HatenaShareButton>
      </ButtonWrapper>
    </Share>
  );
};

export default ShareButtonList;
